export const ru = {
    format: 'Формат',
    operatorName: 'Оператор',
    selected: 'Выбранные'
};
